import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #232129;
  border-radius: 10px;
  padding: 16px;
  width: 100%;

  border: 2px solid #232129;
  color: #665360;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      color: #c53030;
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #439133;
      border: 2px solid #439133;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #439133;
    `}


  input {
    background: transparent;
    flex: 1;
    border: 0;
    color: #f4ede8;

    &::placeholder {
      color: #665360;
    }
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #232129 inset;
  }

  /* Cor do texto do autocomplete */
  input:-webkit-autofill {
    -webkit-text-fill-color: white !important;
  }

  svg {
    margin-right: 16px;
  }
  button {
    background-color: transparent;
    color: #665360;
    border: 0;
    & :hover {
      color: white;
    }
  }
`;

export const Error = styled(Tooltip)`
  margin-left: 16px;

  svg {
    margin-left: -10px;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
